/**
 * Take 1 dimensional array from endpoint response and build a hierarchical tree
 * @param {Array} array 
 */
 export default (array) => {
    // Add a child array to every object in the base array
    const modified = array.map(x => {
        return {...x, children: [] }
    })

    // push the child ids onto their parents
    modified.forEach(item => {
        if (item.parent !== item.child && item.parent !== "0") {
            const parentIndex = modified.findIndex(x => x.child === item.parent)
            if (modified[parentIndex]) { 
              modified[parentIndex].children.push(item); // the child prop is the unique id of the current item
            } else {
              console.error(item) // we found an orphan :(
            }
        }
    })

    // filter out the duplicates.
    return modified.filter(y => y.child === y.parent || y.parent === "0")
}
